import { render, staticRenderFns } from "./KPIItemNew.vue?vue&type=template&id=274c5f72"
import script from "./KPIItemNew.vue?vue&type=script&lang=js"
export * from "./KPIItemNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports